import { MigrationPage } from "./MigrationPage";

// The Custom dashboards (Tableau-embedded) page has migrated to tinuiti-frontend. This stub keeps
// the route reachable from the old app (nav link / legacy links) — MigrationPage reloads so the
// k8s HTTPRoute serves it from tinuiti-frontend.
const CustomTableau = (): JSX.Element => (
  <MigrationPage title="Custom Dashboard" pageType="Custom Dashboard" />
);

export default CustomTableau;
